module.exports = __webpack_public_path__ + "img/PG7-1-498x299.b0ea3687.png";